import { ExhibitorStoreState } from '@core/data-access/models/exhibitor/exhibitor-store.model';
import { ExhibitorActions } from '@core/data-access/store/exhibitor/exhibitor.actions';
import { createFeature, createReducer, on } from '@ngrx/store';
import { isEmpty } from 'lodash';

export const exhibitorFeatureKey = 'exhibitor';

const initialState: ExhibitorStoreState = {
  activeExhibitorCompanyTriple: null,
  exhibitorDetails: null,
  isExhibitorWelcomeMessageModalOpen: false
};

const exhibitorReducer = createReducer(
  initialState,
  on(ExhibitorActions.setActiveExhibitorCompanyTriple, (state, { exhibitorCompanyTriple }) => {
    return {
      ...state,
      activeExhibitorCompanyTriple: exhibitorCompanyTriple
    };
  }),
  on(ExhibitorActions.setExhibitorDetail, (state, { exhibitorDetail, isExhibitorWelcomeMessageModalOpen }) => {
    if (isEmpty(exhibitorDetail)) {
      return state;
    }

    return {
      ...state,
      activeExhibitorCompanyTriple: exhibitorDetail.companyTriple,
      exhibitorDetails: {
        ...state.exhibitorDetails,
        [exhibitorDetail.companyTriple]: exhibitorDetail
      },
      isExhibitorWelcomeMessageModalOpen
    };
  }),
  on(ExhibitorActions.closeExhibitorWelcomeMessageModal, (state) => ({
    ...state,
    isExhibitorWelcomeMessageModalOpen: false
  })),
  on(ExhibitorActions.resetReducer, () => initialState)
);

export const exhibitorFeature = createFeature({
  name: exhibitorFeatureKey,
  reducer: exhibitorReducer
});
